import React from 'react';

import { Display, Flex, Heading, Paragraph } from '@rover/kibble/core';
import type { ThemeHeadingSizes } from '@rover/kibble/styles/themeTypes';

export type HeadingVariant = 'display' | 'heading' | 'static-heading';

type Props = {
  heading: string;
  headingSize?: ThemeHeadingSizes;
  headingVariant: HeadingVariant;
  subheading?: React.ReactNode;
};

const headingVariantComponentMap: Record<
  HeadingVariant,
  (heading: string, headingSize: ThemeHeadingSizes) => React.ReactElement
> = {
  display: (heading, headingSize) => (
    <Display mb="0x" webProps={{ as: 'h2' }} size={headingSize} testID="carousel-display-variant">
      {heading}
    </Display>
  ),
  heading: (heading, headingSize) => (
    <Heading mb="0x" webProps={{ as: 'h2' }} size={headingSize} testID="carousel-heading-variant">
      {heading}
    </Heading>
  ),
  'static-heading': (heading, headingSize) => (
    <Heading
      mb="0x"
      webProps={{ as: 'h2', responsive: false }}
      size={headingSize}
      testID="carousel-static-heading-variant"
    >
      {heading}
    </Heading>
  ),
};

export const Header: React.FC<Props> = ({
  heading,
  headingSize = '400',
  headingVariant,
  subheading,
}) => {
  return (
    <Flex flexDirection="column">
      {headingVariantComponentMap[headingVariant]?.(heading, headingSize)}
      {subheading && (
        <Paragraph mt="2x" mb="3x" size="200">
          {subheading}
        </Paragraph>
      )}
    </Flex>
  );
};
